import axios from 'axios';
import React, { useState } from 'react';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { userStore, updateProfile } from "../../../redux/reduxStore.js";
import Loader from "../../Loader.jsx";

const Adminprofile = () => {
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const [loader, setLoader] = useState(false);
  
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isDirty },
    setValue,
    reset
  } = useForm({
    defaultValues: {
      firstName: user?.userName?.split(" ")?.[0],
      lastName: user?.userName?.split(`${user.userName?.split(" ")[0]}`)[1],
      phone: user.phone
    }
  });
  
  const updateUserProfile = (data) => {
    setLoader(true);
    axios({
      method:"PUT",
      url:`${process.env.REACT_APP_BASE_URL}/user/${user._id}`,
      headers: {
        "Content-Type":"application/json",
        "Authorization":`Bearer ${token}`
      },
      data: {
        userName:`${data.firstName.trim()} ${data.lastName}`,
        phone:data.phone
      }
    }).then(res => {
      userStore.dispatch(updateProfile({userName:`${data.firstName.trim()} ${data.lastName}`, phone:data.phone}));
      setLoader(false);
      reset(data);
      toast(res.data.message, {
        theme:"light",
        position:"top-right",
        type:"success"
      });
    }).catch(err => {
      setLoader(false);
      if(err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          theme:"light",
          position:"top-right",
          type:"error"
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Failed to update profile", {
          theme:"light",
          position:"top-right",
          type:"error"
        });
      }
    });
  }

  return (
    <>
      <section className='form-section userform full'>
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="boxwrap">
                <h2 className='text-gradient'>My Profile</h2>
                <div className="row">

                  <Form.Group as={Col} md="6" className="mb-3" controlId="up-firstname">
                    <Form.Label>First name <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="First name"
                      {...register("firstName", {
                        required:{ message:"First name is require", value:true},
                        minLength:{ message:"First name is not valid", value:2 }
                      })} />
                    { errors.firstName ? <p className='errMsg'>{errors.firstName.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="mb-3" controlId="up-lastname">
                    <Form.Label>Last name <span>*</span></Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Last name"
                      {...register("lastName", {
                        required:{ message:"Last name is require", value:true},
                        minLength:{ message:"Last name is not valid", value:2 }
                      })}/>
                    { errors.lastName ? <p className='errMsg'>{errors.lastName.message}</p> : null }
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="up-emailaddress">
                    <Form.Label>Email address <span>*</span></Form.Label>
                    <Form.Control disabled type="mail" placeholder="Email address" value={`${user.email}`} />
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="mb-3" controlId="up-phonenumber">
                    <Form.Label>Phone number <span>*</span></Form.Label>
                    <Form.Control
                      type="tel"
                      placeholder="Phone number"
                      {...register("phone", {
                        required:{message:"Phone number is require", value:true},
                        pattern: { message:'Phone number is not valid', value:/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/g }
                      })} />
                    { errors.phone ? <p className='errMsg'>{errors.phone.message}</p> : null }
                  </Form.Group>

                  <div className="d-flex align-items-center justify-content-end gap-3">
                    <Button disabled={!isDirty} onClick={handleSubmit(updateUserProfile)} type="submit" className="button blue py-3">Update</Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader}/>
    </>
  )
}

export default Adminprofile